import { money0 } from "@keel/core";
import { Stat } from "@keel/ui";

/** Home dashboard: orders on the floor. */
export function ProductionTile({
  data,
}: {
  data: { inProduction: number; planned: number; late: number; wip: number };
}) {
  return (
    <Stat
      label="In production"
      value={data.inProduction}
      href="/manufacturing"
      tone={data.late ? "danger" : undefined}
      foot={`${data.late ? `${data.late} late · ` : ""}${data.planned} planned · WIP ${money0(data.wip)}`}
    />
  );
}
